// extracted by mini-css-extract-plugin
export default {"image":"bY-z","loaded":"cY-z"};